import {
  LoyaltyTag as LoyaltyTagGrpc,
  LoyaltyTagType as LoyaltyTagTypeGrpc,
  Translation as TranslationGrpc,
} from "gen/witbooking/loyalty/tag/v1/loyalty_tag_api_pb";
import { Translation } from "../../../shared/domain/Translation";
import { LoyaltyTag, LoyaltyTagType } from "../../domain/LoyaltyTag";
import { LoyaltyTagTableDto } from "../dto/LoyaltyTagTableDto";

export class LoyaltyTagMapper {
  static toTableDto(tag: LoyaltyTag, locale: string): LoyaltyTagTableDto {
    return {
      id: tag.id,
      name: tag.getTranslation(locale).name,
      ticker: tag.ticker,
    };
  }

  static toGrpc(tag: LoyaltyTag, brandId: string): LoyaltyTagGrpc {
    const grpcTag = new LoyaltyTagGrpc();
    grpcTag.setId(tag.id);
    grpcTag.setBrandid(brandId);
    grpcTag.setTicker(tag.ticker);
    grpcTag.setType(LoyaltyTagTypeGrpc.PREFERENCE);
    grpcTag.setIcon(tag.icon ?? "");
    grpcTag.setTranslationsList(
      tag.translations.map(t => {
        const translation = new TranslationGrpc();
        translation.setLocale(t.locale);
        translation.setTranslation(t.name);
        translation.setDescription(t.description ?? "");
        return translation;
      })
    );
    return grpcTag;
  }

  static fromGrpc(tag: LoyaltyTagGrpc): LoyaltyTag {
    return LoyaltyTag.of({
      id: tag.getId(),
      ticker: tag.getTicker(),
      type: LoyaltyTagType.PREFERENCE,
      icon: tag.getIcon(),
      translations: tag.getTranslationsList().map(t =>
        Translation.of({
          locale: t.getLocale(),
          name: t.getTranslation(),
          description: t.getDescription(),
        })
      ),
    });
  }
}
